

































































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Client} from '@/models';

import storeClient from '@/stores/modules/client';

import CrudAddressEdit from '@/components/Crud/Address/Edit.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

@Component({
	components: {
		CrudAddressEdit,
		InputCountry,
		InputZipCode,
	}
})
export default class CrudClientAdressesEdit extends AbstractEditVue<Client> {

	public constructor() {
		super(
			storeClient,
			'Client modifié',
			'Client créé',
		);
	}

	public async mounted(): Promise<void> {
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
	}

}
